// Turnstile-scriptet delas av alla formulär på sidan och laddas först när någon börjar fylla i ett
let turnstileLoader = null;

function loadTurnstile() {
    if (!turnstileLoader && window.turnstile) {
        // Redan laddat av något annat på sidan (t.ex. Gravity Forms Turnstile)
        turnstileLoader = Promise.resolve(window.turnstile);
    }
    if (!turnstileLoader) {
        turnstileLoader = new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
            script.async = true;
            script.onload = () => resolve(window.turnstile);
            script.onerror = () => {
                turnstileLoader = null;
                reject(new Error("Turnstile kunde inte laddas"));
            };
            document.head.appendChild(script);
        });
    }
    return turnstileLoader;
}

document.addEventListener("alpine:init", () => {
    Alpine.data("upsalesFormHandler", (params) => ({
        // formId och Upsales-URL finns inte i HTML:en, de hämtas från spärren (Upsales_Gate.php) vid submit
        formType: params.formType,
        formId: "",
        formCid: params.formCid,
        successKey: params.successKey || `form_${params.formType}`,
        form: {},
        errors: {},
        submitted: false,

        // Spamspärr
        startedAt: 0,
        turnstileWidget: null,
        turnstileToken: "",
        sending: false,
        gateError: false,

        // Företagssökning
        companySearchQuery: "",
        companySearchSuggestions: [],
        companySearchSelectedName: "",
        companySearchDuns: "",
        companySearchLoading: false,
        companySearchOpen: false,
        companySearchDebounce: null,

        init() {
            // Läs tidigare status om den finns
            const saved = localStorage.getItem(`upsales_success_${this.successKey}`);
            if (saved === "true") {
                this.submitted = true;
            }

            // Telefonnummerrensning
            const phoneFields = this.$root.querySelectorAll('input[name="Contact.phone"], input[x-model*="Contact.phone"]');
            phoneFields.forEach((field) => {
                field.addEventListener("input", (e) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9+\s-]/g, "");
                    const plusCount = (value.match(/\+/g) || []).length;
                    if (plusCount > 1) value = value.replace(/\+(?=.*\+)/g, "");
                    if (value.includes("+") && value[0] !== "+") value = value.replace(/\+/g, "");
                    e.target.value = value;
                    const match = field.getAttribute("x-model")?.match(/form\[['"](.+?)['"]\]/);
                    if (match) this.form[match[1]] = value;
                });
            });

            // Första interaktionen startar ifyllnadstiden och laddar Turnstile
            this.$root.addEventListener("focusin", () => this.prepareGate());

            // Bakåtknappen från Upsales tacksida återställer sidan från bfcache: släpp knappen och hämta ny token
            window.addEventListener("pageshow", (e) => {
                if (!e.persisted) return;
                this.setSending(false);
                this.resetTurnstile();
            });

            // Klick utanför för att stänga dropdown
            window.addEventListener("click", (e) => {
                if (!this.$root.contains(e.target)) {
                    this.companySearchOpen = false;
                }
            });
        },

        // Företagsfält logik
        companySearchOnInput() {
            this.companySearchDuns = "";
            this.companySearchSelectedName = "";

            if (this.companySearchDebounce) clearTimeout(this.companySearchDebounce);

            if (!this.form["Client.name"] || this.form["Client.name"].length < 3) {
                this.companySearchSuggestions = [];
                this.companySearchOpen = false;
                return;
            }

            this.companySearchDebounce = setTimeout(() => {
                this.companySearchFetch(this.form["Client.name"]);
            }, 200);
        },

        async companySearchFetch(query) {
            this.companySearchLoading = true;
            try {
                const res = await fetch(`https://power.upsales.com/api/external/prospecting/clientSearch?country=SE&name=${encodeURIComponent(query)}`);
                const data = await res.json();
                this.companySearchSuggestions = data.data || [];
                this.companySearchOpen = this.companySearchSuggestions.length > 0;
            } catch (e) {
                console.error("Upsales client search error:", e);
            }
            this.companySearchLoading = false;
        },

        companySearchSelect(client) {
            this.form["Client.name"] = client.name;
            this.form["Client.dunsNo"] = client.dunsNo;
            this.companySearchSelectedName = client.name;
            this.companySearchDuns = client.dunsNo;
            this.companySearchOpen = false;
        },

        companySearchOnChange() {
            if (this.form["Client.name"] !== this.companySearchSelectedName) {
                this.form["Client.dunsNo"] = "";
                this.companySearchDuns = "";
            }
        },

        fieldLabels: {
            "Client.name": "Företag",
            "Client.dunsNo": "DUNS-nummer",
            "Contact.name": "Namn",
            "Contact.firstname": "Förnamn",
            "Contact.lastname": "Efternamn",
            "Contact.email": "E-post",
            "Contact.phone": "Telefon",
            "Extra.1763620062730": "Förfrågan gäller",
            "Extra.1763620166182": "Ankomstdatum",
            "Extra.1763620173536": "Avresedatum",
            "Extra.1763620144650": "Antal deltagare",
            "Extra.1763620243551": "Antal övernattande",
            "Extra.1763620274984": "Övrig information",
            "singleOptIn.1526547984158": "Godkänd integritetspolicy"
        },

        async validate() {
            this.errors = {};
            const formEl = this.$root.querySelector("form");

            // Validera required-fält
            const requiredFields = formEl.querySelectorAll("[required]");
            requiredFields.forEach((el) => {
                let key = el.name;
                if (el.hasAttribute("x-model")) {
                    const match = el.getAttribute("x-model").match(/form\[['"](.+?)['"]\]/);
                    if (match) key = match[1];
                }
                const value = el.type === "checkbox" ? !!el.checked : el.value.trim();
                if (!value) this.errors[key] = "Detta fält är obligatoriskt.";
            });

            // Validera e-post
            const emailFields = formEl.querySelectorAll('input[type="email"]');
            emailFields.forEach((emailField) => {
                const email = emailField.value.trim();
                if (email && !this.validateEmail(email)) {
                    let key = emailField.name;
                    if (emailField.hasAttribute("x-model")) {
                        const match = emailField.getAttribute("x-model").match(/form\[['"](.+?)['"]\]/);
                        if (match) key = match[1];
                    }
                    this.errors[key] = "Ogiltig e-postadress.";
                }
            });

            // Validera telefon
            const phoneFields = formEl.querySelectorAll('input[name="Contact.phone"], input[x-model*="Contact.phone"]');
            phoneFields.forEach((phoneField) => {
                const phone = phoneField.value.trim();
                if (phone && !this.validatePhone(phone)) {
                    let key = phoneField.name;
                    if (phoneField.hasAttribute("x-model")) {
                        const match = phoneField.getAttribute("x-model").match(/form\[['"](.+?)['"]\]/);
                        if (match) key = match[1];
                    }
                    this.errors[key] = "Telefonnumret får endast innehålla siffror, mellanslag, bindestreck och ett + i början.";
                }
            });

            if (Object.keys(this.errors).length > 0) return;

            if (this.sending) return;
            this.setSending(true);
            this.gateError = false;

            const gate = await this.passGate(formEl);
            if (!gate) {
                this.setSending(false);
                this.gateError = true;
                return;
            }

            this.formId = gate.formId;
            formEl.action = gate.action;
            formEl.querySelector('input[name="formId"]').value = gate.formId;

            // Skjut GTM-event
            const eventData = { event: "upsalesFormSubmit", formId: this.formId, formCid: this.formCid };

            for (const key in this.form) {
                if (Object.hasOwn(this.form, key)) {
                    let value = this.form[key];

                    // hoppa över tomma fält
                    if (value === null || value === undefined || value === "" || value === false) {
                        continue;
                    }

                    const label = this.fieldLabels[key] || key;

                    // konvertera boolean → 1/0 som tidigare
                    if (typeof value === "boolean") {
                        value = value ? "1" : "0";
                    }

                    eventData[label] = value;
                }
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(eventData);

            // **Skicka formuläret direkt till Upsales**
            // Kopiera värdena från Alpine-formen till formulärets inputs innan submit
            for (const key in this.form) {
                if (Object.hasOwn(this.form, key)) {
                    let input = formEl.querySelector(`[name="${key}"]`);
                    if (!input) {
                        input = document.createElement("input");
                        input.type = "hidden";
                        input.name = key;
                        formEl.appendChild(input);
                    }
                    input.value = this.form[key];
                }
            }

            // Honeypoten ska inte följa med till Upsales
            formEl.querySelector("[data-upsales-honeypot]")?.remove();

            formEl.submit();
        },

        setSending(sending) {
            this.sending = sending;

            const button = this.$root.querySelector('form button[type="submit"]');
            if (!button) return;

            if (sending) {
                button.dataset.label = button.textContent;
                button.textContent = "Skickar…";
            } else if (button.dataset.label) {
                button.textContent = button.dataset.label;
            }
            button.disabled = sending;
        },

        resetTurnstile() {
            this.turnstileToken = "";
            if (window.turnstile && typeof this.turnstileWidget === "string" && this.turnstileWidget !== "pending") {
                window.turnstile.reset(this.turnstileWidget);
            }
        },

        prepareGate() {
            if (!this.startedAt) this.startedAt = Date.now();

            const siteKey = window.upsalesGate?.siteKey;
            if (!siteKey || this.turnstileWidget !== null) return;

            this.turnstileWidget = "pending";
            loadTurnstile()
                .then((turnstile) => {
                    this.turnstileWidget = turnstile.render(this.$root.querySelector("[data-upsales-turnstile]"), {
                        sitekey: siteKey,
                        action: this.formType,
                        appearance: "interaction-only",
                        "refresh-expired": "auto",
                        // Token skickas till spärren, inte som eget fält till Upsales
                        "response-field": false,
                        callback: (token) => (this.turnstileToken = token),
                        "expired-callback": () => (this.turnstileToken = ""),
                        "error-callback": () => (this.turnstileToken = ""),
                    });
                })
                .catch((e) => {
                    console.error(e);
                    this.turnstileWidget = null;
                });
        },

        // Väntar på token, kan ta en stund om Turnstile visar en utmaning för besökaren
        async getTurnstileToken() {
            if (!window.upsalesGate?.siteKey) return "";

            this.prepareGate();
            const deadline = Date.now() + 20000;
            while (!this.turnstileToken && Date.now() < deadline) {
                await new Promise((resolve) => setTimeout(resolve, 200));
            }
            return this.turnstileToken;
        },

        async passGate(formEl) {
            try {
                const token = await this.getTurnstileToken();
                const res = await fetch(window.upsalesGate.endpoint, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        type: this.formType,
                        token,
                        hp: formEl.querySelector("[data-upsales-honeypot] input")?.value || "",
                        elapsed: this.startedAt ? Date.now() - this.startedAt : 0,
                    }),
                });
                if (!res.ok) throw new Error(`Upsales gate ${res.status}`);
                return await res.json();
            } catch (e) {
                console.error(e);
                // Token är förbrukad (eller saknas), hämta en ny inför nästa försök
                this.resetTurnstile();
                return null;
            }
        },

        validateEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },

        validatePhone(phone) {
            return /^\+?[0-9\s-]+$/.test(phone);
        },
    }));
});

//# sourceMappingURL=upsales-form-handler.js.map
